export default {
      id: "princess-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#princess",
      toString: function () {
        return this.url;
      }
    }